// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1n-7";
export var adjustableWidthBorderHeld = "_1n-8";
export var arrow = "_1n-3";
export var arrowButton = "_1n-4";
export var headerCell = "_1n-0";
export var help = "_1n-2";
export var icon = "_1n-1";
export var iconWrapper = "_1n-6";
export var noBorder = "_1n-b";
export var nonAdjustableWidthBorder = "_1n-9";
export var nonAdjustableWidthBorderHeld = "_1n-a";
export var textButton = "_1n-5";